// extracted by mini-css-extract-plugin
export default {"paddinglessCollapse":"collapse_paddinglessCollapse__DGZk1"};